import { t } from 'i18next';
import { useState, useEffect } from 'react';

import { Stack } from '@mui/system';
import { TextField, Typography } from '@mui/material';

// ----------------------------------------------------------------------

type DialpadAuthState = {
  api_key: string;
};

type Props = {
  onChange: (state: DialpadAuthState) => void;
};

export default function DialpadAuthSettings({ onChange }: Props) {
  const [apiKey, setApiKey] = useState('');

  useEffect(() => {
    onChange({ api_key: apiKey });
  }, [apiKey, onChange]);

  return (
    <Stack spacing={3}>
      <Typography variant="h6">
        {t('integrations.manual_auth.dialpad.title')}
      </Typography>

      <TextField
        fullWidth
        label={t('integrations.manual_auth.dialpad.api_key')}
        value={apiKey}
        onChange={(e) => setApiKey(e.target.value)}
        placeholder={t('integrations.manual_auth.dialpad.api_key_placeholder')}
        type="password"
        autoComplete="off"
      />

      <Typography variant="caption" color="text.secondary">
        {t('integrations.manual_auth.dialpad.help')}
      </Typography>
    </Stack>
  );
}
